<template>

  <div class="row">
    <div class="col-md-6 col-md-offset-3 col-sm-6 col-md-offset-3">
        <transition name="el-fade-in-linear" mode="out-in" v-if="!collapsed">
          <form method="#" action="#">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Unsubscribe</h4>
                <p class="category">To unsubscribe, please let us know why you no longer need reminders of your application.</p>
              </div>
              <div class="card-content">
                <div class="form-horizontal" data-vv-scope="user-form">
                  <div class="form-group">
                    <label class="col-sm-2 control-label">
                      Reason<span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-10 form-control-static">
                      <el-select v-model="reason" v-bind:value="reason" class="col-sm-12">
                        <el-option value="I'm no longer applying to that organisation."/>
                        <el-option value="I used a different route to verify or supply credentials."/>
                        <el-option value="The service was too expensive."/>
                        <el-option value="I could not find my school or provider listed."/>
                        <el-option value="I could not find the help or assistance I needed to complete my application."/>
                        <el-option value="The website did not work properly, I could not complete my application."/>
                        <el-option value="Will complete the application, do not need reminders."/>
                        <el-option value="My payment was not accepted."/>
                        <el-option value="Other / prefer not to say."/>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer row">
                <div class="col-md-12">
                  <button @click.prevent="submitForm" @click="toggleForm()" type="submit" class="btn btn-fill btn-wd btn-default pull-right" v-bind:disabled="!reason" v-bind:class="{'btn-disabled': !reason}"><span class="btn-label"><i class="fa fa-floppy-o"></i></span>Submit</button>
                </div>
              </div>
            </div>

          </form>
      </transition>

      <transition name="el-fade-in-linear" mode="out-in" v-if="collapsed">
        <div class="card col-md-11 col-md-offset-1 col-sm-11 col-sm-offset-1">
            <div class="card-header">
              <h4 class="card-title">Unsubscribed successfully.</h4>
              <p class="category">You will no longer receive reminders regarding your application.</p>
              <br/>
            </div>
        </div>
      </transition>
    </div>
  </div>

</template>
<script>

  export default {
    components: {

    },
    data () {
      return {
        collapsed: false,
        reason: null,
        appid:null
      }
    },
    created () {
      this.appid = this.$route.params.appid
        ? this.$route.params.appid
        : this.$route.query.appid
    },
    methods: {
      toggleForm() {
        this.collapsed = true
      },

      submitForm() {
        this.$validator.validate().then((result) => {
          if (result) {
            this.$api
            .postUnsubscribeData({
                applicationId: this.appid,
                reason: this.reason
                })
            .catch((error) => {
              console.log(error);
            });
          }
        })},

    beforeDestroy () {
      this.closeMenu();
    }
  }}
</script>
<style>
</style>
